/**
 * Коды ошибок общие для пакета и контрактов: Tact бросает те же номера, поэтому
 * тест на кривую и тест на контракт сравниваются по одному коду, а не по тексту.
 */
export const ExitCode = {
  deadlinePassed: 700,
  slippage: 701,
  notActive: 702,
  insufficientGas: 703,
  zeroAmount: 704,
  devBuyLimit: 705,
  curveFull: 706,
  unauthorized: 707,
  launchesPaused: 708,
  alreadyInitialized: 709,
  unknownPayload: 710,
  unknownJettonWallet: 711,
  metadataTooLong: 712,
  insufficientValue: 713,
  nothingToClaim: 714,
  notChannelRecipient: 715,
  notInitialized: 716,
  reserveUnderflow: 717,
  insufficientBalance: 718,
  wrongWorkchain: 719,
  notGraduating: 720,
  unknownDex: 721,
  dexParams: 722,
  harvestUnsupported: 723,
  nothingToHarvest: 724,
  harvestInProgress: 725,
  alreadyGraduated: 726,
  phase1Pending: 727,
} as const;

export type ExitCodeName = keyof typeof ExitCode;

export class CurveError extends Error {
  readonly code: number;

  constructor(name: ExitCodeName, message?: string) {
    super(message ?? `curve-math: ${name} (exit code ${ExitCode[name]})`);
    this.name = 'CurveError';
    this.code = ExitCode[name];
  }
}

export function fail(name: ExitCodeName, message?: string): never {
  throw new CurveError(name, message);
}
